import React from "react"
import Arrow from "../../../../../../assets/images/Inner/arrow.svg";
import Line from "../../../../../../assets/images/dashboard/line.svg";
import { getNotesFromLuci } from "../../../../../../utils/constants"

import Plus from "../../../../../../assets/images/dashboard/plus.svg";
import Minus from "../../../../../../assets/images/dashboard/minus.svg";
import Equal from "../../../../../../assets/images/dashboard/equal.svg";

// for CardDetailsByGraph
import CardDetailsByGraph from "../component/CardDetailsByGraph"
import {
    getFeaturesIcon, 
    getToolTipConstant,
    valueWithCommas,
    commaSeparator,
    firstYear,
    secondYear,
    lastYear,
} from "../../../../../../utils/constants"
import Rate from "../../../../../../assets/images/dashboard/rate.svg";
import Prize from "../../../../../../assets/images/dashboard/prize.svg";
import { Tooltip, Divider } from "antd";
import Help from "../../../../../../assets/images/dashboard/help-icon.svg";
const getOtherRewards = (otherObject) => {
    try {
        return JSON.parse(otherObject) || {}
    } catch (e) {
        return {}
    }
}



function SeeMoreDetailsFeatures(args) {
    
    const {
        card,
        updateCarouselHeight,
        topIncludedIntroBonus,
        cardDetailsByGraphObj = {},
    } = args;
    
    const {
        moreDetailInfo,
        moreDetailNotes,
        rewardDetail,
        calculation,
        points,
        annualFee = "",
        annualFeeDetail = [],
        introMoney,
        introPoints,
        unitForPoints = "",
        introOfferDetail = [],
        totalMoney,
        totalMoneyPerYear,
    } = card;
    
    //
    const { isReward, isIntro, isAnnual } = calculation || {};
    
    // 
    const {
        stat, money, avgSpending, spending, onGetDate, selectedDate, topYearProjection,
        rewardInfoLong, features, otherRewards, annualFeeDisplay, annualFeeGeneralDetail, 
        creditRange, rewardRate, rewardRateGeneralDetail, introOffer, introOfferGeneralDetail,
    } = cardDetailsByGraphObj;
    
    // states
    const [isExpanded, setIsExpanded] = React.useState(false);
    const [isVisible, setIsVisible] = React.useState(false);
    const [isFadeIn, setIsFadeIn] = React.useState(false);
    
    // trigger update carousel height
    const isExpandComplete = isExpanded && isVisible && isFadeIn;
    const prevIsExpandComplete = React.useRef(false);
    if (prevIsExpandComplete.current != isExpandComplete && updateCarouselHeight) {
        prevIsExpandComplete.current = isExpandComplete;
        updateCarouselHeight();
    }
    const isShrinkComplete = !isExpanded && !isVisible && !isFadeIn;
    const prevIsShrinkComplete = React.useRef(true); // initially shrunk
    if (prevIsShrinkComplete.current != isShrinkComplete && updateCarouselHeight) {
        prevIsShrinkComplete.current = isShrinkComplete;
        updateCarouselHeight();
    }
    
    // do expand animation first, then show the expanded contents
    React.useEffect(() => {
        if (isExpanded) {
            // expand parent, then show child with delay
            const timeout = setTimeout(() => {
                setIsVisible(true);
                setTimeout(() => setIsFadeIn(true), 0);
            }, 0);
            return () => clearTimeout(timeout);
        } else {
            const timeout = setTimeout(() => {
                setIsVisible(false);
                setIsFadeIn(false);
            }, 0);
            return () => clearTimeout(timeout);
        }
    }, [isExpanded]);
    
    // 
    return (
        
        <div className={"card-carousel-expandable" + (isExpanded? " expanded" : "")}>
            
            {/* toggle */}
            <div
                className="card-carousel-expandable-toggle ga-ccAddlDetails ga-ccAddlDetails-features"
                onClick={() => setIsExpanded(!isExpanded)}
            >
                <div>
                    Features & Details
                </div>
                <div>
                    {isExpanded?
                        <img src={Arrow} className=""/>
                        :
                        <img src={Arrow} className="" style={{transform: "rotate(180deg)"}}/>
                    }
                </div>
            </div>
            
            <div className={"card-carousel-expanded" + (isFadeIn? "" : " fading-in")} style={{display: isVisible? null : "none"}}>
                
                {/*  */}
                <div className="card-carousel-section">
                    {
                        (features || []).map((feature, index) => (
                          <div className="card-carousel-feature" key={index.toString()}>
                              <img src={getFeaturesIcon(feature) || Rate}/>
                              <div>{feature}</div>
                          </div>
                        ))
                    }
                    {
                        (Object.keys(getOtherRewards(otherRewards)) || []).map((rewardKey, index) => (
                          <div className="card-carousel-feature" key={index.toString()}>
                              <img src={Prize}/>
                              <div>
                                  {rewardKey || ""}
                                  { getOtherRewards(otherRewards)?.[rewardKey] &&
                                      <Tooltip
                                          title={getToolTipConstant([getOtherRewards(otherRewards)?.[rewardKey]] || [])}
                                          trigger={["hover", "click"]}
                                      >
                                          <img className="gray-help ml-2" src={Help}/>
                                      </Tooltip>
                                  }
                              </div>
                          </div>
                        ))
                    }
                </div>
                
                <Divider style={{marginTop: 20, marginBottom: 20}}/>
                
                {/* details */}
                <div className="card-carousel-section">
                    {(moreDetailInfo || []).map((reward, index) => {
                        
                        // dumb html saved in backend? parse it here for now
                        let label = "";
                        let text = "";
                        const match = reward.match(/<b>(.*?)<\/b>:\s*(.*)/);
                        if (match) {
                          label = match[1];
                          text = match[2];
                        }
                        
                        return (
                            <div className="card-carousel-details" key={index.toString()}>
                              <div className="card-carousel-details-label">
                                {label}
                              </div>
                              <div className="card-carousel-details-text">
                                {text}
                              </div>
                            </div>
                        );
                    })}
                </div>
                
                <Divider style={{marginTop: 20, marginBottom: 20}}/>
                
                {/* notes */}
                <div className="card-carousel-section">
                    <div className="card-carousel-section-title">
                        Notes from luci
                    </div>
                    {(moreDetailNotes || []).map((note, index) => (
                        <div className="card-carousel-notes" key={index.toString()}>
                            <div className="card-carousel-notes-icon-container">
                                <img src={getNotesFromLuci(note, "src")}/>
                            </div>
                            <div className="card-carousel-notes-text">
                                {getNotesFromLuci(note, "text")}
                            </div>
                        </div>
                    ))}
                
                </div>
                
            </div>
        </div>
    );
    
}



export default SeeMoreDetailsFeatures
